import { useContext } from 'react';

import { UpdateItemSetQuestionConditionsContext } from './update-item-set-question-conditions-provider';

function useUpdateItemSetQuestionConditions() {
  const context = useContext(UpdateItemSetQuestionConditionsContext);

  if (!context) {
    throw new Error(
      'useUpdateItemSetQuestionConditions must be used within a UpdateItemSetQuestionConditionsProvider',
    );
  }

  return context;
}

export { useUpdateItemSetQuestionConditions };
